import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";

// Fetching Data from the API]

// End

// Page Html
export default function RespondToSituation() {
  const [RespondToSituationData, setRespondToSituationData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRespondToSituationData = async () => {
      try {
        const response = await fetch("/api/questions/respondtosituation", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setRespondToSituationData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch RespondToSituationData data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching Readaloud data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchRespondToSituationData();
  }, []); // Empty dependency array to fetch data only once on mount

  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Respond to  Situation" id={RespondToSituationData.data} />

    </div>
  );
}
